import { CallEmsApi, iEmsApiResponse, iEmsApiResponseBody } from "../Logic/TenantAPI";

export interface iDataColumn {
    id: number;
    name: string;
}

export interface iTemplate {
    id: number;
    name: string;
    sourceID: number;
    subject: string;
    body: string;
    include: string;
    actions: number[];
    mailboxes: number[];
    updatedAt: Date;
}

export async function GetTemplate(tenantToken: string, id: number): Promise<iEmsApiResponseBody<iTemplate>> {
    return await CallEmsApi<iTemplate>(tenantToken, "GET", `Config/Template/${id}`);
}

export async function UpdateTemplate(
    tenantToken: string,
    template: iTemplate,
): Promise<iEmsApiResponseBody<iTemplate>> {
    template.body = template.body.replace(/&lt;/g, "<");
    template.body = template.body.replace(/&gt;/g, ">");
    return await CallEmsApi<iTemplate>(tenantToken, "PUT", `Config/Template/${template.id}`, template);
}

export async function CreateTemplate(
    tenantToken: string,
    template: iTemplate,
): Promise<iEmsApiResponseBody<iTemplate>> {
    return await CallEmsApi<iTemplate>(tenantToken, "POST", `Config/Template/`, template);
}

export async function DeleteTemplate(tenantToken: string, id: number): Promise<iEmsApiResponseBody<any>> {
    return await CallEmsApi<any>(tenantToken, "DELETE", `Config/Template/${id}`);
}
